import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as TabelasConveniosActions } from "../ducks/tabelasConvenios";
import { Creators as TabelasConveniosStoresActions } from "../ducks/PageStores/tabelasConveniosStores";
import { Creators as ModalActions } from "../ducks/modal";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as PageActions } from "../ducks/pages";
import moment from "moment";
import { formatReal } from "../../helpers";

export function* getListTabelasConvenios() {
  try {
    yield put(LoadingActions.setLoading());
    const { page, rowsPerPage, filter } = yield select(
      state => state.tabelasConvenios
    );
    const { data: permissions } = yield select(state => state.permissions);
    const { action } = yield select(state => state.tabelasConveniosStores);
    if (action === "EXPORT") {
      filter.export = true;
    }
    const { data } = yield call(
      api.post,
      `/convenets/filter?page=${page + 1}&&per_page=${rowsPerPage}`,
      filter
    );
    const { data: tabelasConvenios, total } = data;
    let tabelasConveniosPayload = [];
    tabelasConveniosPayload = tabelasConvenios.map(tabelaConvenio => ({
      id: tabelaConvenio.id,
      name: tabelaConvenio.name,
      bank: tabelaConvenio.bank.name,
      promoter: tabelaConvenio.promoter && tabelaConvenio.promoter.name,
      product: tabelaConvenio.product.name,
      operation: tabelaConvenio.operation.name,
      deadline: `${tabelaConvenio.initial_interval} ⟶ ${
        tabelaConvenio.finish_interval
      }`,
      goals_percent: tabelaConvenio.goals_percent + "%",
      validity: `${moment(tabelaConvenio.started_at).format("DD/MM/YYYY")} ⟶ ${
        tabelaConvenio.finished_at !== null
          ? moment(tabelaConvenio.finished_at).format("DD/MM/YYYY")
          : "Indefinido"
      }`,
      receipts:
        permissions.indexOf("VISUALIZAR COMISSÕES DAS PROPOSTAS") > 0
          ? tabelaConvenio.receipt_settings
              .map(
                receipt =>
                  `<span class='tag'>
                  <i class='fa fa-external-link'></i>
                  <span class='tag-child'>
                    <span class='tag-row'>
                      <span>
                        ${receipt.description}:
                      </span>
                      <span>
                        ${receipt.percent}%
                      </span>
                      <span>
                        +
                      </span>
                      <span>
                        ${formatReal(
                          receipt.amount !== null ? receipt.amount : 0
                        )}
                      </span>
                    </span>
                    ${receipt.comissions
                      .map(
                        comission => `
                      <span class='tag-row'>
                        <span>
                          ${comission.description}:
                        </span>
                        <span>
                          ${comission.percent}%
                        </span>
                        <span>
                          +
                        </span>
                        <span>
                          ${formatReal(
                            comission.amount !== null ? comission.amount : 0
                          )}
                        </span>
                      </span>
                    `
                      )
                      .join("")}
                  </span>
                </span>`
              )
              .join("")
          : tabelaConvenio.receipt_settings
              .map(
                receipt => `
              ${receipt.comissions
                .map(
                  comission => `
                  <span class='tag'>
                    <i class='fa fa-external-link'></i>
                      <span class='tag-child'>
                        <span class='tag-row'>
                          <span>
                            ${comission.description}:
                          </span>
                          <span>
                            ${comission.percent}%
                          </span>
                          <span>
                            +
                          </span>
                          <span>
                            ${formatReal(comission.amount)}
                          </span>
                        </span>
                      </span>
                  </span>
              `
                )
                .join("")}
          `
              )
              .join("")
    }));
    const name = "Tabelas de Convênios";
    const path = "tabelas-de-convenios";
    yield put(PageActions.setPage(name, path));
    yield put(
      TabelasConveniosActions.getListTabelasConveniosSuccess(
        tabelasConveniosPayload,
        total,
        data.export
      )
    );
    if (action === "EXPORT") {
      window.open(data.export, "_blank");
      yield put(TabelasConveniosStoresActions.setAction("LIST"));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getTabelasConvenios({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/convenets/${payload.id}`);
    yield put(TabelasConveniosActions.getTabelasConveniosSuccess(data));
    const { action } = yield select(state => state.tabelasConveniosStores);
    if (action === "EDIT" || action === "DETAIL" || action === "REPLICA") {
      yield put(ModalActions.open());
    } else {
      const title = "Aviso de exclusão";
      const body = `O cadastro "${data.name}" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editTabelasConvenios({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/convenets/${payload.id}`, payload);
    yield put(TabelasConveniosActions.getListTabelasConvenios());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addTabelasConvenios({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/convenets`, payload);
    yield put(TabelasConveniosActions.searchTabelasConvenios({}));
    yield put(TabelasConveniosActions.getListTabelasConvenios());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* replicaTabelasConvenios({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const {tabelaFinalizada, novaTabela} = payload;
    tabelaFinalizada.finished_at = tabelaFinalizada.finished_at.subtract(1, 'days').format("DD/MM/YYYY");
    yield call(api.patch, `/convenets/finish-many`, tabelaFinalizada);
    yield call(api.post, `/convenets`, novaTabela);
    yield put(TabelasConveniosActions.searchTabelasConvenios({}));
    yield put(TabelasConveniosActions.getListTabelasConvenios());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Tabela atualizada com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteTabelasConvenios() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.tabelasConvenios.item);
    yield call(api.delete, `/convenets/${id}`);
    yield put(TabelasConveniosActions.getListTabelasConvenios());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchTabelasConvenios() {
  try {
    yield put(TabelasConveniosActions.getListTabelasConvenios());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllTabelasConvenios({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/convenets/destroy-many`, {
      convenets_id: payload.selected
    });
    yield put(TabelasConveniosActions.getListTabelasConvenios());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* encerraTabelasConvenios({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.patch, `/convenets/finish-many`, payload);
    yield put(TabelasConveniosActions.getListTabelasConvenios());
    yield put(SuccessActions.openSuccess("Vigências encerradas com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/tabelasConvenios.js